import { Validator } from '@vista-digital/validator';
import { HeadingLevel } from '../../../../subcomponents';
export const eventDescriptionConfigValidator = Validator.object({
    labelHeadingLevel: Validator.oneOf(Object.values(HeadingLevel))
});
export const defaultEventDescriptionConfig = {
    labelHeadingLevel: HeadingLevel.H3
};
